import { Directive, ElementRef, inject, Input, NgZone } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import type { Observable } from 'rxjs';

@UntilDestroy()
@Directive({
  selector: '[umeDisableUntilResolve]',
  standalone: true,
  host: {
    '(click)': 'onClick()',
  },
})
export class DisableUntilResolveDirective {
  private _el: ElementRef<HTMLElement> = inject(ElementRef<HTMLElement>);
  private _zone: NgZone = inject(NgZone);

  @Input() loadingState?: Observable<boolean>;

  onClick(): void {
    this._el.nativeElement.setAttribute('disabled', 'disabled');

    this.loadingState?.pipe(untilDestroyed(this)).subscribe((b: boolean) => {
      if (!b) {
        this._zone.runOutsideAngular(() => {
          this._el.nativeElement.removeAttribute('disabled');
        });
      } else {
        this._el.nativeElement.setAttribute('disabled', 'disabled');
      }
    });
  }
}
